// React
import { useCallback } from 'react'

// Interfaces
import { IBaseLabelStatusProps } from './interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// Constant
import { ACTIVE_STRING, INACTIVE_STRING, DRAFT, PUBLISH, USER_STATUS, FORM_STATUS } from 'constant/shared.constant'

// Mobx
import { observer } from 'mobx-react'

const BaseLabelStatus = observer(({ isBoolean, isUserStatus, isCompanyType, value, isNews, isString }: IBaseLabelStatusProps) => {
  // Hook
  const { t } = useTranslation()

  /**
   * @description Render color
   *
   * @return {string} string
   */
  const renderColor = useCallback((): string => {
    switch (value) {
      case DRAFT:
        return 'warning'
      case INACTIVE_STRING:
      case USER_STATUS.WAITING_APPROVAL:
      case USER_STATUS.REJECTED:
        return 'danger'
      case PUBLISH:
      case USER_STATUS.APPROVED:
      case FORM_STATUS.FILLED:
        return 'success'
      case ACTIVE_STRING:
        return 'primary'
      case FORM_STATUS.NOT_FILLED:
        return 'grey'
      default:
        return ''
    }
  }, [value])

  /**
   * @description Render label
   *
   * @return {JSX.Element} JSX.Element
   */
  const renderLabel = useCallback((): JSX.Element => {
    if (isBoolean) {
      return (
        <p className={`font-weight-400 text-${value ? 'success' : 'danger'}`}>
          {t(`app.status.${value ? 'active' : 'inactive'}`)}
        </p>
      )
    } else if (isUserStatus || isNews || isString) {
      return <p className={`font-weight-700 text-${renderColor()}`}>{value || '-'}</p>
    } else if (isCompanyType) {
      if (value) {
        return <p className={`font-weight-400`}>{t(`app.companyType.${value === '1' ? 'internal' : 'external'}`)}</p>
      } else {
        return <>-</>
      }
    } else {
      return <></>
    }
  }, [isBoolean, value, isUserStatus, isNews, isCompanyType, isString, renderColor, t])

  return renderLabel()
})

export { BaseLabelStatus }
